import React, { useEffect, useState, lazy } from 'react';
import { motion } from 'framer-motion';
import { Eye, Ticket, Users, CreditCard, Clock, Sparkles, ArrowRight } from 'lucide-react';
export function PurchaseSection() {
  const [viewers, setViewers] = useState(7);
  const [spots, setSpots] = useState(5);
  const [totalAccessed, setTotalAccessed] = useState(3265);
  const [currentDate, setCurrentDate] = useState('');
  useEffect(() => {
    const today = new Date();
    const formatted = today.toLocaleDateString('es-AR', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
    setCurrentDate(formatted.charAt(0).toUpperCase() + formatted.slice(1));
    const viewerInterval = setInterval(() => {
      setViewers(prev => {
        const change = Math.random() > 0.5 ? 1 : -1;
        const newValue = prev + change;
        return Math.max(5, Math.min(10, newValue));
      });
    }, 4000);
    const spotInterval = setInterval(() => {
      // Subtle pulse effect for spots
      setSpots(prev => prev);
    }, 10000);
    return () => {
      clearInterval(viewerInterval);
      clearInterval(spotInterval);
    };
  }, []);
  return <section id="compra" className="py-20 px-4 bg-gradient-to-b from-[#111] to-[#0a0a0a] scroll-mt-20 pt-[45px] pb-[45px]" data-id="element-285">
      <div className="max-w-4xl mx-auto" data-id="element-286">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-287">
          <h2 className="md:text-6xl font-black text-white mb-8 text-[28px]" data-id="element-288">
            FORMACIÓN EN DETALLADO AUTOMOTOR
          </h2>
        </motion.div>

        <div className="relative bg-gradient-to-b from-[#1a1a1a] via-[#141210] to-[#0a0a0a] border border-brand-yellow/40 rounded-3xl p-8 md:p-12 shadow-[0_0_60px_rgba(245,197,24,0.2),0_0_120px_rgba(245,197,24,0.05)] mb-12 overflow-hidden group premium-noise premium-vignette" data-id="element-289">
          {/* Premium inner glow and ambient lights */}
          <div className="absolute inset-0 bg-gradient-to-b from-brand-yellow/5 to-transparent pointer-events-none" data-id="element-290" />

          {/* Radial golden spotlight from center-top */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] pointer-events-none" style={{
          background: 'radial-gradient(ellipse at center top, rgba(245, 197, 24, 0.08) 0%, rgba(245, 197, 24, 0.03) 30%, transparent 70%)'
        }} data-id="element-291" />

          {/* Diagonal golden accent lines */}
          <div className="absolute inset-0 pointer-events-none overflow-hidden opacity-[0.04]" style={{
          backgroundImage: 'repeating-linear-gradient(135deg, transparent, transparent 40px, rgba(245, 197, 24, 1) 40px, rgba(245, 197, 24, 1) 41px)'
        }} data-id="element-292" />

          {/* Corner accent - top left */}
          <div className="absolute top-0 left-0 w-24 h-24 pointer-events-none" data-id="element-293">
            <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-brand-yellow/40 to-transparent" data-id="element-294" />
            <div className="absolute top-0 left-0 h-full w-[1px] bg-gradient-to-b from-brand-yellow/40 to-transparent" data-id="element-295" />
          </div>

          {/* Corner accent - top right */}
          <div className="absolute top-0 right-0 w-24 h-24 pointer-events-none" data-id="element-296">
            <div className="absolute top-0 right-0 w-full h-[1px] bg-gradient-to-l from-brand-yellow/40 to-transparent" data-id="element-297" />
            <div className="absolute top-0 right-0 h-full w-[1px] bg-gradient-to-b from-brand-yellow/40 to-transparent" data-id="element-298" />
          </div>

          {/* Corner accent - bottom left */}
          <div className="absolute bottom-0 left-0 w-24 h-24 pointer-events-none" data-id="element-299">
            <div className="absolute bottom-0 left-0 w-full h-[1px] bg-gradient-to-r from-brand-yellow/30 to-transparent" data-id="element-300" />
            <div className="absolute bottom-0 left-0 h-full w-[1px] bg-gradient-to-t from-brand-yellow/30 to-transparent" data-id="element-301" />
          </div>

          {/* Corner accent - bottom right */}
          <div className="absolute bottom-0 right-0 w-24 h-24 pointer-events-none" data-id="element-302">
            <div className="absolute bottom-0 right-0 w-full h-[1px] bg-gradient-to-l from-brand-yellow/30 to-transparent" data-id="element-303" />
            <div className="absolute bottom-0 right-0 h-full w-[1px] bg-gradient-to-t from-brand-yellow/30 to-transparent" data-id="element-304" />
          </div>

          {/* Ambient light blobs */}
          <div className="absolute -top-32 -right-32 w-72 h-72 bg-brand-yellow/15 blur-[100px] rounded-full pointer-events-none group-hover:bg-brand-yellow/25 transition-colors duration-700" data-id="element-305" />
          <div className="absolute -bottom-32 -left-32 w-72 h-72 bg-brand-yellow/8 blur-[100px] rounded-full pointer-events-none" data-id="element-306" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-brand-yellow/5 blur-[120px] rounded-full pointer-events-none" data-id="element-307" />

          <div className="relative z-10" data-id="element-308">
            <div className="bg-gradient-to-r from-red-500/20 to-orange-500/20 border border-red-500 rounded-xl p-2.5 mb-8 max-w-md mx-auto pt-[3px] pb-[3px] pl-[22px] pr-[22px]" data-id="element-309">
              <div className="flex items-center justify-center gap-2 flex-wrap" data-id="element-310">
                <p className="text-xs md:text-sm font-black text-white text-center uppercase tracking-wider" data-id="element-311">
                  OFERTA VÁLIDA SOLO POR HOY:{' '}
                  <span className="text-red-400" data-id="element-312">{currentDate}</span>
                </p>
              </div>
            </div>

            <div className="text-center mb-10" data-id="element-313">
              <p className="text-gray-500 line-through mb-2 text-lg md:text-xl font-bold" data-id="element-314">
                Antes $49.990 ARS
              </p>
              <div className="relative inline-block mb-6" data-id="element-315">
                <motion.div animate={{
                scale: [1, 1.02, 1]
              }} transition={{
                duration: 3,
                repeat: Infinity,
                ease: 'easeInOut'
              }} className="relative z-10" data-id="element-316">
                  <p className="text-6xl md:text-8xl font-black text-transparent bg-clip-text bg-gradient-to-b from-white via-gray-200 to-gray-400 drop-shadow-[0_0_20px_rgba(255,255,255,0.3)]" data-id="element-317">
                    $19.990 <span className="text-2xl md:text-4xl" data-id="element-318">ARS</span>
                  </p>
                </motion.div>
                <div className="absolute -inset-8 bg-brand-yellow/15 blur-3xl -z-10 rounded-full animate-pulse" data-id="element-319" />
              </div>

              <div className="flex justify-center" data-id="element-320">
                <div className="relative inline-flex text-white px-6 py-2.5 rounded-full font-black overflow-hidden group/badge items-center justify-center gap-2 bg-[#03D34D] shadow-[0_0_25px_rgba(3,211,77,0.4)] border border-white/20" data-id="element-321">
                  <CreditCard className="w-4 h-4" data-id="element-322" />
                  <span className="text-xs md:text-sm uppercase tracking-tight" data-id="element-323">
                    Hasta 3 cuotas sin interés
                  </span>
                  <div className="absolute top-0 -inset-full h-full w-1/2 z-5 block transform -skew-x-12 bg-gradient-to-r from-transparent to-white opacity-40 animate-shine" data-id="element-324" />
                </div>
              </div>
            </div>

            <a href="https://booknova.shop/cart/56939082055840:1" target="_blank" rel="noopener noreferrer" className="relative overflow-hidden group/btn text-black font-black py-4 px-6 md:py-6 md:px-10 rounded-2xl text-[15px] sm:text-xl md:text-3xl flex gap-2 md:gap-4 transition-all duration-500 transform hover:scale-[1.03] active:scale-[0.98] shadow-[0_0_50px_rgba(245,197,24,0.5),inset_0_2px_0_rgba(255,255,255,0.5)] w-full uppercase tracking-tighter items-center justify-center whitespace-nowrap border-b-8 border-[#B8860B] bg-gradient-to-br from-[#F5C518] via-[#FFD700] to-[#E5B800] hover:border-b-4 hover:translate-y-1" data-id="element-325">
              
              <span className="relative z-10 drop-shadow-md" data-id="element-326">
                SÍ, QUIERO LA OFERTA AHORA
              </span>
              <ArrowRight className="w-6 h-6 md:w-9 md:h-9 relative z-10 group-hover/btn:translate-x-2 transition-transform duration-300 flex-shrink-0" data-id="element-327" />

              {/* Premium shine effect */}
              <div className="absolute top-0 -inset-full h-full w-1/2 z-5 block transform -skew-x-12 bg-gradient-to-r from-transparent via-white/70 to-transparent opacity-0 group-hover/btn:opacity-100 group-hover/btn:animate-[shine_1.5s_infinite] pointer-events-none" data-id="element-328" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-white/20 pointer-events-none" data-id="element-329" />
            </a>

            <div className="flex mt-8 px-5 py-2 gap-8 items-center justify-center opacity-90" data-id="element-330">
              <div className="flex items-center gap-2.5" data-id="element-331">
                <div className="relative flex items-center justify-center" data-id="element-332">
                  <div className="w-1.5 h-1.5 bg-green-500 rounded-full" data-id="element-333" />
                  <div className="absolute inset-0 w-1.5 h-1.5 bg-green-500 rounded-full animate-ping opacity-75" data-id="element-334" />
                </div>
                <p className="text-[11px] md:text-xs font-medium text-gray-400 uppercase tracking-widest" data-id="element-335">
                  Mirando ahora:{' '}
                  <span className="text-white font-bold ml-1" data-id="element-336">{viewers}</span>
                </p>
              </div>

              <div className="w-px h-3 bg-gray-800" data-id="element-337" />

              <div className="flex items-center gap-2.5" data-id="element-338">
                <div className="relative" data-id="element-339">
                  <Ticket className="w-3 h-3 text-red-500/80" data-id="element-340" />
                  <motion.div animate={{
                  opacity: [0.4, 1, 0.4]
                }} transition={{
                  duration: 2,
                  repeat: Infinity
                }} className="absolute inset-0 bg-red-500/20 blur-sm rounded-full" data-id="element-341" />
                </div>
                <p className="text-[11px] md:text-xs font-medium text-gray-400 uppercase tracking-widest" data-id="element-342">
                  Cupos:{' '}
                  <span className="text-red-500 font-black ml-1" data-id="element-343">{spots}</span>
                </p>
              </div>
            </div>

            <div className="mt-8 flex flex-col items-center gap-6" data-id="element-344">
              <img src="https://cdn.magicpatterns.com/uploads/u7qFqp7GX1Yb1ifMErU2CL/Mercado_Pago.jpg" alt="Medios de pago - Mercado Pago" width={448} height={150} loading="lazy" className="w-full max-w-md rounded-xl" data-id="element-345" />
              <div className="flex items-center justify-center gap-6" data-id="element-346">
                <img src="https://cdn.magicpatterns.com/uploads/ptNbA1jXBiQTsMBRUcEdGs/garantia_7_dias.png" alt="Garantía 7 días" width={96} height={96} loading="lazy" className="w-20 h-20 md:w-24 md:h-24 object-contain" data-id="element-347" />
                <img src="https://cdn.magicpatterns.com/uploads/5M5t52d6XS2MrGP26UXcKi/compra_asegurada.png" alt="Compra segura" width={150} height={72} loading="lazy" className="h-14 md:h-18 object-contain" data-id="element-348" />
              </div>
            </div>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex justify-center mt-12" data-id="element-349">
          <div className="relative w-full max-w-[320px] aspect-[9/16] rounded-[2rem] overflow-hidden border-4 border-brand-yellow/20 shadow-[0_0_50px_rgba(245,197,24,0.15)] bg-black" data-id="element-350">
            <video src="https://cdn.magicpatterns.com/uploads/o9FoDXEZuwzsypjTPe5fFb/0502(1).mp4" autoPlay loop muted playsInline preload="none" className="w-full h-full object-cover" data-id="element-351" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent pointer-events-none" data-id="element-352" />
          </div>
        </motion.div>
      </div>
    </section>;
}